import { ActionCreator } from "./functions";
export default ActionCreator("LIST");
